import { render, staticRenderFns } from "./PowerSpeed.vue?vue&type=template&id=62565a25&scoped=true&"
import script from "./PowerSpeed.vue?vue&type=script&lang=ts&"
export * from "./PowerSpeed.vue?vue&type=script&lang=ts&"
import style0 from "./PowerSpeed.vue?vue&type=style&index=0&id=62565a25&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62565a25",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VProgressCircular,VSkeletonLoader,VSpacer,VTextField,VTooltip})
